import { render, staticRenderFns } from "./close-outlined.vue?vue&type=template&id=1da8ea01&scoped=true&"
var script = {}
import style0 from "./close-outlined.vue?vue&type=style&index=0&id=1da8ea01&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da8ea01",
  null
  
)

export default component.exports